import React, { Component } from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './dashboard_graph.scss';

const MIN_WIDTH_COMPLETED_BAR = 8;
const MIN_WIDTH_INPROGRESS_BAR = 16;

class DashboardGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hideAnimation: true,
    };
  }

  componentDidMount() {
    _.defer(() => this.setState({ hideAnimation: false }), 1500);
  }

  render() {
    const { data, title, total } = this.props;
    const type = 's-assigned';

    const graphData = _.map(_.filter(data, d => d.count > 0), d => {
      let percent = 0;
      const calculatedPercent = Math.ceil((d.count / total) * 100);

      if (d.type === 's-finished') {
        percent = calculatedPercent > MIN_WIDTH_COMPLETED_BAR ? calculatedPercent : MIN_WIDTH_COMPLETED_BAR;
      }
      if (d.type === 's-in-progress') {
        percent = calculatedPercent > MIN_WIDTH_INPROGRESS_BAR ? calculatedPercent : MIN_WIDTH_INPROGRESS_BAR;
      }

      return {
        ...d,
        percent,
      };
    });
    return (
      <div className="dashboard-graph__content">
        <div
          className={classNames('dashboard-graph', {
            '-hide-animation': this.state.hideAnimation,
          })}
        >
          {_.map(
            graphData,
            (item, i) =>
              _.get(item, 'percent') > 0 && (
                <div
                  className={`dashboard-graph__row ${item.type}`}
                  data-next-bgr={graphData[i + 1] && graphData[i + 1].type}
                  key={i}
                  style={{ width: `${item.percent}%` }}
                >
                  <span className="dashboard-graph__label">
                    {item.title}
                    <i className="dashboard-graph__icon icon-tick" />
                  </span>
                </div>
              ),
          )}
        </div>
        <h2 className={`dashboard-graph__title ${type}`}>{title}</h2>
      </div>
    );
  }
}

DashboardGraph.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      count: PropTypes.number,
      title: PropTypes.string,
      type: PropTypes.string,
    }),
  ),
  title: PropTypes.string,
  total: PropTypes.number,
};

export default DashboardGraph;
